import { render, staticRenderFns } from "./SsbSetupNew.vue?vue&type=template&id=078a8ffe"
import script from "./SsbSetupNew.vue?vue&type=script&lang=js"
export * from "./SsbSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports